import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { MglMap, MglMarker, MglNavigationControl, MglGeolocateControl } from 'vue-mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';
import MapService from '../../../../services/mapService';
import { mapState } from 'vuex';
import { randomInt } from '../../../../utils/vuex';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
var kLayerZIndex1 = 'z-index-1';
var kLayerZIndex2 = 'z-index-2';
export default {
  name: 'NiotaClassicGwMgmtMapInstance',
  components: {
    MglMap: MglMap,
    MglMarker: MglMarker,
    MglNavigationControl: MglNavigationControl,
    MglGeolocateControl: MglGeolocateControl
  },
  props: {
    cameraObj: {
      type: Object,
      required: true
    },
    animateFlyIn: {
      type: Boolean,
      required: false,
      default: function _default() {
        return true;
      }
    },
    items: {
      type: Array,
      required: true
    },
    clusters: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      realCamera: {
        center: [9.7027, 52.3736],
        zoom: 7,
        bearing: randomInt(90) - 90
      },
      clusterRefreshInterval: null,
      light: 'mapbox://styles/mapbox/light-v9',
      dark: 'mapbox://styles/mapbox/dark-v10',
      dmStreets: 'mapbox://styles/digimondo/cjn4e7kzsjv8w2rlc0a574xu4',
      satellite: 'mapbox://styles/mapbox/satellite-v9',
      streets: 'mapbox://styles/mapbox/streets-v11',
      hasLoadedMarkers: false,
      lastBoundsRefresh: {
        _ne: {
          lng: 0,
          lat: 0
        },
        _sw: {
          lng: 0,
          lat: 0
        }
      },
      selectedItem: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    markerColor: function markerColor() {
      return MapService.markerColor(this.color, this.$store);
    },
    mapAccessToken: function mapAccessToken() {
      return !this.$store.state.app.UiTheme ? MapService.getAccessToken('light') : MapService.getAccessToken('dark');
    },
    mapStyle: function mapStyle() {
      if (!this.$store.state.app.mapStyle) {
        // TODO: use proper store.commit action to mutate vuex store
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$store.state.app.mapStyle = localStorage.getItem('mapStyle');
      }

      switch (this.$store.state.app.mapStyle) {
        case '2':
          return this.satellite;

        case '3':
          return this.streets;

        case '4':
          return this.dmStreets;

        default:
          return !this.$store.state.app.UiTheme ? this.light : this.dark;
      }
    }
  }),
  watch: {
    items: function items() {
      if (this.hasLoadedMarkers) {
        return;
      }

      if (this.map && this.items.length > 0 || this.clusters.length > 0) {
        this.hasLoadedMarkers = true;

        if (this.map) {
          this.flyToCamera();
        }
      }
    },
    clusters: function clusters() {
      if (this.hasLoadedMarkers) {
        return;
      }

      if (this.map && (this.items.length > 0 || this.clusters.length > 0)) {
        this.hasLoadedMarkers = true;

        if (this.map) {
          this.flyToCamera();
        }
      }
    },
    mapStyle: function mapStyle() {
      // if the map-style changes, need to reload the map, in order for the polygons to render again
      this.addZIndexHelperLayers();
    }
  },
  created: function created() {
    this.map = null;
  },
  methods: {
    closePopup: function closePopup() {
      this.selectedItem = {};
    },
    onMapLoaded: function onMapLoaded(event) {
      this.map = event.map;
      this.addZIndexHelperLayers();

      if (this.map) {
        this.flyToCamera();
      } // Add 3D Buildings in case switched on in filter


      if (this.$store.state.app.map3DBuild) {
        MapService.add3DBuildingLayer(this.map);
      }

      this.$emit('mapLoad', event.map);
    },
    flyToCamera: debounce(function () {
      var _this = this;

      setTimeout(function () {
        _this.map.flyTo({
          center: _this.cameraObj.center,
          pitch: 15,
          zoom: _this.cameraObj.zoom > 0 ? _this.cameraObj.zoom : 7,
          bearing: 0,
          duration: _this.animateFlyIn ? 2000 : 0,
          animate: _this.animateFlyIn
        });
      }, 100);
    }, 100),
    addZIndexHelperLayers: function addZIndexHelperLayers() {
      if (this.map) {
        if (this.map.getLayer(kLayerZIndex1)) {
          this.map.removeLayer(kLayerZIndex1);
        }

        if (this.map.getLayer(kLayerZIndex2)) {
          this.map.removeLayer(kLayerZIndex2);
        }

        if (this.map.getSource('empty')) {
          this.map.removeSource('empty');
        } // since there is no direct z-index property, create dummy layers under which stuff is positioned


        this.map.addSource('empty', {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: []
          }
        }); // TODO: check if zIndex1 and zIndex2 are still needed
        // eslint-disable-next-line no-unused-vars

        var zIndex2 = this.map.addLayer({
          id: kLayerZIndex2,
          type: 'symbol',
          source: 'empty'
        }); // eslint-disable-next-line no-unused-vars

        var zIndex1 = this.map.addLayer({
          id: kLayerZIndex1,
          type: 'symbol',
          source: 'empty'
        }, kLayerZIndex2); // place this layer below zIndex2
      }
    },
    updateMarkers: debounce(function () {
      var _this2 = this;

      var bounds = this.map.getBounds();
      var screenWidth = this.$refs.map.$el.clientWidth;
      var boundsWidths = {
        lng: Math.abs(bounds['_sw'].lng - bounds['_ne'].lng) / screenWidth,
        lat: Math.abs(bounds['_sw'].lat - bounds['_ne'].lat) / screenWidth
      };

      if (Object.keys(this.lastBoundsRefresh || {}).some(function (position) {
        return Object.keys(get(_this2.lastBoundsRefresh, position, [])).some(function (latOrLong) {
          // can move the map around for 5 pixels before refreshing, little performance optimisation
          // mostly only valid for the same zoom-level
          return Math.abs(bounds[position][latOrLong] - get(_this2.lastBoundsRefresh, "".concat(position, ".").concat(latOrLong))) > boundsWidths[latOrLong] * 5;
        });
      })) {
        this.requestClusterRequest(bounds);
      }
    }, 333),
    debouncedRequestClusterRequest: debounce(function () {
      this.requestClusterRequest();
    }, 333),
    requestClusterRequest: function requestClusterRequest() {
      var bounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      this.lastBoundsRefresh = bounds || this.map ? this.map.getBounds() : null;
      this.$emit('map-moved', {
        bounds: this.lastBoundsRefresh ? [[this.lastBoundsRefresh['_ne'].lng, this.lastBoundsRefresh['_ne'].lat], [this.lastBoundsRefresh['_sw'].lng, this.lastBoundsRefresh['_sw'].lat]] : null
      });

      if (this.clusterRefreshInterval) {
        clearInterval(this.clusterRefreshInterval);
      }

      this.clusterRefreshInterval = setInterval(this.requestClusterRequest, 45000);
    },
    zoomIntoCluster: function zoomIntoCluster(cluster) {
      this.map.fitBounds(cluster.bbox);
    },
    markerClicked: function markerClicked(item) {
      this.selectedItem = item;
      this.zoomToCoordinates(get(item, 'coordinates.coordinates'));
    },
    zoomToCoordinates: function zoomToCoordinates(coordinates) {
      if (!coordinates || !Array.isArray(coordinates) || coordinates.length < 2) {
        return;
      }

      var bounds = this.map.getBounds();
      var mapDimensions = {
        width: this.$refs.map.$el.clientWidth,
        height: this.$refs.map.$el.clientHeight
      }; // do not change the zoom-level, if there is no polygon, as there is nothing to zoom to

      var zoomLevel = undefined;
      var boundsWidth = Math.abs(bounds['_sw']['lng'] - bounds['_ne']['lng']); // the popup window is 600px wide, so offset half of that

      var moveLng = boundsWidth / mapDimensions.width * 300;
      var flyToParams = {
        center: [coordinates[0] + moveLng, coordinates[1]],
        bearing: 0,
        duration: 2000,
        animate: true
      };

      if (zoomLevel) {
        flyToParams['zoom'] = Math.min(Math.max(this.map.getZoom() - 1.0, zoomLevel), this.map.getZoom() + 1.0);
        flyToParams['pitch'] = 25;
      }

      this.map.flyTo(flyToParams);
    }
  }
};